<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button v-permission="'setting.product.syncERPToOrder'" type="primary" size="mini" @click="handle('syncERPToOrder')">
                    <icon-sync size="13" style="marginRight:5px;"/>
                    {{ $t('product.syncERPToOrder') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.product.syncERPToOrder'"/>
                <a-button type="primary" size="mini" v-permission="'setting.product.exportProduct'" :disabled="exporting" @click="handle('exportFile')">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('product.exportFile') }}
                </a-button>
            </template>

            <template v-slot:columns="{props}">
                <div v-if="props.column.key == 'inventory'">
                    <div v-if="props.record.inventory.length > 0">
                        <div v-for="(item,index) in props.record.inventory" :key="index" style="font-size:12px;">
                            {{ item.label }}: <span style="display:inline_block;margin-left:10px"> {{ item.value }} </span>
                        </div>
                    </div>
                    <p v-else>-</p>
                </div>
                <div v-if="props.column.key == 'scheduling_quantity'">
                    <div v-if="props.record.scheduling_quantity.length > 0">
                        <div v-for="(item,index) in props.record.scheduling_quantity" :key="index" style="font-size:12px;">
                            {{ item.label }}: <span style="display:inline_block;margin-left:10px"> {{ item.value }} </span>
                        </div>
                    </div>
                    <p v-else>-</p>
                </div>
            </template>
        </Table>


        <!-- 新增 -->
        <a-modal 
            class="recordModal"
            v-model:visible="visible"
            :width="1200"
            draggable
            :onBeforeOk="onBeforeOk"
            @ok="handleAdd" 
            @cancel="handleCancel"
            
        >
            <template #title> {{ modalTitle }}</template>
            <Form 
                class="addForm"
                :form="addForm"
                @handleBlur="handleBlur"
                @handleInputChange="handleInputChange"
                @handleSelectChange="handleAddSelectChange">
            </Form>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick } from 'vue';
    import { ProductApi } from '@/api/ProductApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { ProductListQuery, AddForm } from './queryConfig/ProductListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';

    const localeStore = useLocale()

    const { t } = useI18n()

    const visible = ref(false)
    const operateType = ref('add')
    const rowData = ref()
    const modalTitle = ref(t('product.addProduct'))
    const queryForm = reactive(ProductListQuery)
    const addForm = reactive(AddForm)
    const exporting = ref(false)
    const showForm = ref(false)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: 'SKU',
                title: t('product.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '物料编码',
                title: t('product.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '产品名称(英文)',
                title: t('product.englishName'),
                dataIndex: 'english_name',
                key:'english_name',
                width:'400',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '上市年份/车型',
                title: t('product.modelYearModel'),
                dataIndex: 'model_year_model',
                key:'model_year_model',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '品牌名称',
                title: t('product.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'140',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '零件名称',
                title: t('product.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'140',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '库存激活状态',
                title: t('product.activeStatus'),
                dataIndex: 'inventory_item_status_code',
                key:'inventory_item_status_code',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '库存',
                title: t('product.inventory'),
                dataIndex: 'inventory',
                key:'inventory',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '计划出库数量',
                title: t('product.schedulingQuantity'),
                dataIndex: 'scheduling_quantity',
                key:'scheduling_quantity',
                width:'200',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '扭矩/车架尺寸/颜色/重量',
                title: t('product.torqueSizeColorWeight'),
                dataIndex: 'torque_size_color_weight',
                key:'torque_size_color_weight',
                width:'250',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '版本',
                title: t('product.hfVersion'),
                dataIndex: 'hf_version',
                key:'hf_version',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '状态',
                title: t('product.inventoryItemStatusCode'),
                dataIndex: 'inventory_item_status_code',
                key:'inventory_item_status_code',
                width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '类型名称',
                title: t('product.categoryName'),
                dataIndex: 'category_name',
                key:'category_name',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '创建日期',
                title: t('product.createDate'),
                dataIndex: 'create_date',
                key:'create_date',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     title: t('base.operate'),
            //     dataIndex: 'Optional',
            //     key:'Optional',
            //     slotName:'optional',
            //     width:'200',
            //     align:'center',
            //     fixed:'right'
            // }
        ],
        configs:{
            scroll:{
                x:1000,
                y:540,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getProductList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                table.value.configs.pagination.current = 1
                getProductList()
                break;
            case 'add':
                visible.value = true
                operateType.value = 'add'
                modalTitle.value = t('product.addProduct')
                addForm.formField.forEach(i=>{
                    addForm.formData[i.key] = ''
                })
                break;
            case 'edit':
                visible.value = true
                modalTitle.value = t('product.editProduct')
                for(let key in addForm.formData){
                    addForm.formData[key] = row[key]
                }
                operateType.value = 'edit'
                rowData.value = row
                break;
            case 'delete':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('product.delConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        delProduct(row)
                    }
                }); 
                break;
            case 'syncERPToOrder':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('order.syncConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        syncERPToOrder()
                    }
                });
                break;
            case 'exportFile':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile()
                    }
                });
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getProductList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getProductList()
    }

    // 列表查询-select
    const handleSelectChange = (val, opt, key)=>{
        addForm.formData[key] = val
        table.value.configs.pagination.current = 1
        getProductList()
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getProductList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getProductList()
    }

    const handleInputChange = (item,val)=>{
        if(item.key == 'inventory_code' && addForm.formData.inventory_code == ''){
            item.helpMsg = ''
            item.validateStatus = ''
        }
    }

    const handleBlur = (item)=>{
        if(item.key == 'inventory_code' && addForm.formData.inventory_code !== ''){
            checkInventory(addForm.formData[item.key])
        }
    }
    
    const vaild = async ()=>{
        if(!addForm.formData.sku){
            Message.error(t('product.skuTip'))
            return false
        }else if(!addForm.formData.inventory_code){
            Message.error(t('product.inventoryCodeTip'))
            return false
        }else if(!addForm.formData.english_name){
            Message.error(t('product.englishNameTip'))
            return false
        }else if(!addForm.formData.torque){
            Message.error(t('product.torqueTip'))
            return false
        }else if(!addForm.formData.frame){
            Message.error(t('product.frameTip'))
            return false
        }

        return true
    }

    const onBeforeOk = ()=>{
        return vaild()
    }

    const handleAdd =  ()=>{
        operateType.value == 'add'? addProduct() : editProduct(rowData.value)
    }

    // 导出订单/导出订单车辆
    const exportFile = async (type)=>{
        let param = {}
        for(let key in queryForm.formData){
            param[key] = queryForm.formData[key]
        }
        param.need_inventory_flag = 1 // 查erp库存
        Message.success(t('base.exporting'))
        exporting.value = true
        table.value.configs.loading = true
        let res = await ProductApi.getInstance().exportFile(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download =  `${t('product.productData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            exporting.value = false
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }
    

    // 获取产品列表
    const getProductList = async ()=>{
        let param = {
            ...queryForm.formData,
            inventory_code:queryForm.formData.inventory_code.trim(),
            sku:queryForm.formData.sku.trim(),
            need_inventory_flag:1, // 查erp库存
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await ProductApi.getInstance().getProductList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                let inventory = [],  scheduling_quantity = []
                for(let key in item.inventory){
                    inventory.push({
                        label:key,
                        value:item.inventory[key] + ' ' + item.unit_code
                    })
                }
                for(let key in item.scheduling_quantity){
                    scheduling_quantity.push({
                        label:key,
                        value:item.scheduling_quantity[key] + ' ' + item.unit_code
                    })
                }

                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    inventory: inventory,
                    scheduling_quantity: scheduling_quantity,
                    torque: item.torque == undefined? '-' : item.torque,
                    frame: item.frame == undefined? '-' : item.frame,
                    frame_size: item.frame_size == undefined? '-' : item.frame_size,
                    frame_color: item.frame_color == undefined? '-' : item.frame_color,
                    unit_code: item.unit_code == undefined? '-' : item.unit_code,
                    unit_weight: item.unit_weight == undefined? '-' : item.unit_weight,
                    weight_uom_code:item.weight_uom_code == undefined? '' : item.weight_uom_code,
                    hf_version:item.hf_version == undefined? '-' : item.hf_version,
                    model_year: item.model_year == undefined? '-' : item.model_year,
                    model: item.model == undefined? '-' : item.model,
                    brand_name: item.brand_name == undefined? '-' : item.brand_name,
                    part_name: item.part_name == undefined? '-' : item.part_name,
                    // torque_size_color_weight: item.unit_weight == undefined? `${item.torque} / ${item.frame_size} / ${item.frame_color} / -` : `${item.torque} / ${item.frame_size} / ${item.frame_color} / ${item.unit_weight}`,
                    // model_year_model: `${item.model_year} / ${item.model}`,
                })
            })

            table.value.datas.forEach(item=>{
                item.torque_size_color_weight =  item.torque == '-' && item.frame_size == '-' && item.frame_color == '-' && item.unit_weight == '-'? '-' : `${item.torque} / ${item.frame_size} / ${item.frame_color} / ${item.unit_weight} ${item.weight_uom_code}`
                item.model_year_model = item.model_year == '-' && item.model == '-'? '-' : `${item.model},${item.model_year}`
            })

            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 新增产品
    const addProduct = async ()=>{
        let param = {
            ...addForm.formData,
        }
        let res = await ProductApi.getInstance().addProduct(param)
        if(res.code == 0){
            Message.success(t(`base.addSuccess`))
            getProductList()
        }else{
            Message.error(t(`base.addFail`) + res.msg)
        }
    }

    // 编辑产品
    const editProduct = async (row)=>{
        console.log(row,'rowData')
        let param = {
            ...addForm.formData,
        }
        let res = await ProductApi.getInstance().editProduct(param,row.id)
        if(res.code == 0){
            Message.success(t(`base.editSuccess`))
            getProductList()
        }else{
            Message.error(t(`base.editFail`) + res.msg)
        }
    }

    //删除辑产品
    const delProduct = async (row)=>{
        let res = await ProductApi.getInstance().delProduct(row.id)
        if(res.code == 0){
            Message.success(t(`base.delSuccess`))
            getProductList()
        }else{
            Message.error(t(`base.delFail`) + res.msg)
        }
    }

    // 检验物料编码
    const checkInventory = async (code)=>{
        let item = addForm.formField.find(i=> i.key == 'inventory_code')
        let res = await ProductApi.getInstance().checkInventory({inventory_code:code})
        if(res.code == 0){
            item.helpMsg = ''
            item.validateStatus = ''
        }else{
            item.helpMsg = res.msg
            item.validateStatus = 'error'
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await ProductApi.getInstance().getWarehouse()
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'warehouse')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.description,
                    value: i.subinventory_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 同步ERP产品到订单
    const syncERPToOrder = async ()=>{
        table.value.configs.loading = true
        let res = await ProductApi.getInstance().syncERPToOrder()
        if(res.code == 0){
            Message.success(t('base.syncSuccess'))
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取品牌名称
    const getBrandName = async ()=>{
        let res = await ProductApi.getInstance().getBrandName()
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'brand_name')
            res.data.length > 9 && res.data.forEach(i=>{
                item.options.push({
                    label:i.brand_name,
                    value:i.brand_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取零件名称
    const getPartName = async ()=>{
        let res = await ProductApi.getInstance().getPartName()
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'part_name')
            res.data.length > 9 && res.data.forEach(i=>{
                item.options.push({
                    label:i.part_name,
                    value:i.part_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到SKU和物料编码下拉数据
    const getSkuAndInventoryCodeList = async ()=>{
        let res = await StockOutApi.getInstance().getProductList({simple_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=>i.key == 'sku')
            let item2 = queryForm.formField.find(i=>i.key == 'inventory_code')
            let item3 = queryForm.formField.find(i=>i.key == 'english_name')
            item.options = []
            item2.options = []
            item3.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku
                })
                item2.options.push({
                    label:i.inventory_code,
                    value:i.inventory_code
                })
                item3.options.push({
                    label:i.english_name,
                    value:i.english_name
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    const getBomCategory = async ()=>{
        let param = {
            dict_code:'system',
            dict_sub_code:'product_category'
        }
        let res = await StockOutApi.getInstance().getCategory(param)
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'category_code')
            item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 30
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 100
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(()=>{ 
        getProductList()
        getSkuAndInventoryCodeList()
        // getWarehouse()
        getBrandName()
        getPartName()
        getBomCategory()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-tabs-content {
    padding-top: 5px;
}

/deep/ .arco-table-td{
    padding: 0;
    border-bottom: none;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 10px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.addForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-picker-size-medium,
    /deep/ .arco-select-view-single{
        height: 45px;
    }

    /deep/ .arco-form-item-label-col{
        line-height: 45px;
    }
    
}

/deep/ .arco-form-item-layout-inline{
    margin-right:10px;
}

</style>